import { PaymentMethodIcon } from '@change/ds-core-ui';

import { usePaymentMethodIconsWrapper } from './hooks/usePaymentMethodIconsWrapper';

export const PaymentMethodIconsWrapper: React.FC = () => {
	const {
		data: { applePay, googlePay },
	} = usePaymentMethodIconsWrapper();

	return (
		<div className="flex justify-center">
			<div className="flex flex-row gap-0.5">
				{applePay && <PaymentMethodIcon type="applepay" variant="card" />}
				{googlePay && <PaymentMethodIcon type="googlepay" variant="card" />}
				<PaymentMethodIcon type="paypal" variant="card" />
				<PaymentMethodIcon type="visa" variant="card" />
				<PaymentMethodIcon type="mastercard" variant="card" />
				<PaymentMethodIcon type="americanexpress" variant="card" />
				<PaymentMethodIcon type="discover" variant="card" />
			</div>
		</div>
	);
};
